










































































































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from "../../../../../../Mixins/ModelSetter";
import BindTopicInput from "../../../../../BindTopicInput.vue";
import TextInput from "../../../../../Pi/fields/TextInput/TextInput.vue";
import { MessageEditorComponentSettings } from "../../../../types";

@Component({
  components: {
    BindTopicInput,
    TextInput
  }
})
export default class TopicsSelect extends Mixins(ModelSetter) {
  @Prop() topics!: Array<number>

  @Prop({ type: Object }) topicsOptions?: MessageEditorComponentSettings['topics']

  @Prop() disabled!: boolean

  @Emit()
  resetTopics(): this {
    return this
  }

  @Emit()
  pickTopic(id: number): number {
    return id
  }

  isOpen = false

  topicValue = ''

  resetTopicsHandler(): void {
    this.resetTopics()
    this.isOpen = false
  }

  afterModalClose() {
    this.topicValue = ''
  }

  pickTopicHandler(id: number): void {
    this.pickTopic(id)

    if (this.topicsOptions && this.topicsOptions.limit === 1) {
      this.isOpen = false
    }
  }
}
